import "./EmailLoginForm.css";

import cx from "classnames";
import PropTypes from "prop-types";
import React from "react";

import IframeFormGroup from "../../components/IframeFormGroup";
import { formFieldShape } from "../../components/stateForm";
import SubmitButton from "../../components/SubmitButton";
import TextMessage from "../../text/TextMessage";

/**
 * Renders the login form. It contains the provided form fields and
 * it allows a loading state for the submit button.
 */
export default function EmailLoginForm(
  { formFields: { email, password }, isLoading, onSubmit },
  { t: translate }
) {
  return (
    <form className={cx("emailLoginForm")} noValidate onSubmit={onSubmit}>
      <IframeFormGroup hasError={!!email.error}>
        <label htmlFor="email">{translate("auth.login.email.label")}</label>
        <input
          className={cx({ "has-error": !!email.error })}
          data-testid="email"
          id="email"
          onBlur={email.onBlur}
          onChange={email.onChange}
          onInput={email.onBlur}
          placeholder={translate("auth.login.email.placeholder")}
          type="email"
          value={email.value}
        />
        {!!email.error && (
          <div className="emailLoginForm-errorMessage">
            <TextMessage message="auth.login.email.error_format" />
          </div>
        )}
      </IframeFormGroup>
      <IframeFormGroup hasError={!!password.error}>
        <label htmlFor="password">
          {translate("auth.login.password.label")}
        </label>
        <a
          className="emailLoginForm-forgotPassword"
          href="/reset-password"
          tabIndex={-1}
          target="_parent"
        >
          {translate("auth.login.forgot_password")}
        </a>
        <input
          className={cx({ "has-error": !!password.error })}
          data-testid="password"
          id="password"
          onBlur={password.onBlur}
          onChange={password.onChange}
          onInput={password.onBlur}
          placeholder={translate("auth.login.password.placeholder")}
          type="password"
          value={password.value}
        />
        {!!password.error && (
          <div className="emailLoginForm-errorMessage">
            <TextMessage message="auth.login.password.required" />
          </div>
        )}
      </IframeFormGroup>
      <SubmitButton
        className="emailLoginForm-button"
        data-testid="submitLoginButton"
        isFluid
        isLoading={isLoading}
        type="submit"
      >
        {translate("auth.login.log_in")}
      </SubmitButton>
    </form>
  );
}

EmailLoginForm.propTypes = {
  formFields: PropTypes.shape({
    email: formFieldShape,
    password: formFieldShape,
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

EmailLoginForm.contextTypes = {
  t: PropTypes.func.isRequired,
};
